module.exports = __webpack_public_path__ + "static/media/fireplace.9bfc18ce.svg";